import { render, staticRenderFns } from "./vNavbar.vue?vue&type=template&id=0bb0095c&scoped=true&"
import script from "./vNavbar.vue?vue&type=script&lang=js&"
export * from "./vNavbar.vue?vue&type=script&lang=js&"
import style0 from "./vNavbar.vue?vue&type=style&index=0&id=0bb0095c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb0095c",
  null
  
)

/* custom blocks */
import block0 from "./vNavbar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports